import { Api } from "../config/request";

export default {
  getUserPropertyList(query) {
    return Api.get("/user_properties?" + query);
  },
  createUserProperty(payload) {
    return Api.post("/user_properties", payload);
  },
  updateUserProperty(payload) {
    return Api.put("/user_properties", payload);
  },
  getUserPropertyKeys() {
    return Api.get("/user_properties/keys");
  },
  getUserProperty(id) {
    return Api.get(`/user_properties/${id}`);
  },
};
